


























































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import courseListeners, {
  CourseListenersListParams
} from "@/getinfo-api/course-listeners";
import { CourseListenersList as ICourseListenersList } from "@/api/models/course-listeners-list";
import api from "@/getinfo-api";
import { CourseProgress as ICourseProgress } from "@/api/models/course-progress";
import { practiceStatusFormatter } from "@/plugins/statuses";
import { isRoot, getCurrentUserId, getCurrentCompanyId } from "@/plugins/roles";
import { CourseListenerPass as ICourseListenerPass } from "@/api/models/course-listener-pass";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import {
  isAllowEditDates,
  studentDocumentModule,
  switchFrontVersionModule
} from "@/plugins/modules-detect";
import moment from "moment/moment";
import UserStudentFiles from "@/components/user/UserStudentFiles.vue";
import Modal from "@/components/form/Modal.vue";

@Component({
  components: {
    Modal,
    UserStudentFiles,
    CustomButton,
    CustomDatepicker,
    CustomTableCol,
    CustomTableItem
  }
})
export default class ListenersInRequestListItem extends Vue {
  @Prop() user!: ICourseListener;
  @Prop() listenerIds!: Array<string>;
  @Prop() courseId!: string;
  listener!: ICourseListener;
  showSpinner: boolean = true;
  progress!: ICourseProgress;
  createdAt!: string | undefined;
  userNotListenerShow: boolean = false;
  isEditDateShow: boolean = false;

  data() {
    return {
      createdAt: undefined,
      listener: undefined,
      progress: undefined
    };
  }

  get companyId(): string {
    return getCurrentCompanyId();
  }

  get isAllowEditDates() {
    return isAllowEditDates();
  }

  changeListenerDate(id: string, date: Date) {
    //@ts-ignore
    let created = new Date(this.createdAt);
    api.CourseApi.listenerEditCreatedAt(created, this.courseId, id)
      //@ts-ignore
      .then((res: { data: ICourseListener }) => {
        this.listener = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isEditDateShow = false;
      });
  }

  get isStudentDocumentModule() {
    return studentDocumentModule();
  }

  getProgressByCourse() {
    this.showSpinner = true;
    api.CourseApi.listenerProgress(this.courseId, this.listener.id)
      .then((res: { data: ICourseProgress }) => {
        this.progress = res.data;
        this.createdAt = this.listener.createdAt
          ? moment(this.listener.createdAt).format("YYYY-MM-DD")
          : undefined;
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  getListenerByUserId() {
    if (this.courseId) {
      let params: CourseListenersListParams = {
        id: this.courseId,
        userId: this.user.id
      };

      courseListeners(params).then((res: { data: ICourseListenersList }) => {
        if (res.data.listeners.length) {
          this.listener = res.data.listeners.filter(el =>
            this.listenerIds.includes(el.id)
          )[0];
          this.getProgressByCourse();
        } else {
          this.userNotListenerShow = true;
        }
      });
    }
  }

  get testProgress() {
    return this.progress.test
      ? this.formattedTestStatus(this.progress.test.success)
      : this.$tc(this.$translate.NotAttached);
  }

  formattedTestStatus(success: boolean): string {
    return success
      ? this.$tc(this.$translate.Success)
      : this.$tc(this.$translate.Failed);
  }

  get practiceProgress() {
    return this.progress.practice
      ? practiceStatusFormatter(this.progress.practice.status)
      : this.$tc(this.$translate.NotAttached);
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyEmployee() {
    return this.$store.getters.userIsEmployee;
  }

  get learningRequestManager() {
    return this.$store.getters.roles.includes("learning_request_manager");
  }

  get userIsCourseOwner() {
    return this.listener
      ? this.listener.course.owner.id === this.userId
      : false;
  }

  get canSeeUserResult() {
    return (
      this.root ||
      this.companyOwner ||
      this.userIsCourseOwner ||
      this.learningRequestManager
    );
  }

  endLearning() {
    this.showSpinner = true;
    //@ts-ignore
    this.progress = undefined;
    let passParams: ICourseListenerPass = {
      listenerId: this.listener.id,
      success: true
    };
    api.CourseApi.pass(this.courseId, [passParams])
      .then(() => {
        this.getProgressByCourse();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  mounted() {
    this.getListenerByUserId();
  }
}
